import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FiscContratosLogged from '../../../../components/auth/contratos/fiscais'

function FiscContratosLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Fiscais de Contratos" />
                <HeaderLogged />
                <Container>
                   <FiscContratosLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default FiscContratosLoggedScreen;